import React, { useState } from "react";
import {
  Popover,
  TextField,
  Button,
  makeStyles,
  Box,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  popover: {
    padding: theme.spacing(2),
    width: 300,
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));

/**
 * LinkPopover Component
 *
 * A popover component for inserting links
 *
 * @param {Object} props - Component props
 * @param {HTMLElement} props.anchorEl - The element to anchor the popover to
 * @param {Function} props.onClose - Callback for when the popover is closed
 * @param {Function} props.onInsertLink - Callback for when a link is inserted
 * @returns {JSX.Element} The rendered component
 */
const LinkPopover = ({ anchorEl, onClose, onInsertLink }) => {
  const classes = useStyles();
  const open = Boolean(anchorEl);
  const [linkText, setLinkText] = useState("");
  const [linkUrl, setLinkUrl] = useState("");

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onInsertLink) {
      onInsertLink(linkText, linkUrl);
    }
    resetForm();
  };

  // Reset form fields
  const handleCancel = () => {
    resetForm();
    onClose();
  };

  // Reset form fields
  const resetForm = () => {
    setLinkText("");
    setLinkUrl("");
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleCancel}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box className={classes.popover}>
        <Typography variant="h6" className={classes.title}>
          Insert Link
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Link Text"
            value={linkText}
            onChange={(e) => setLinkText(e.target.value)}
            fullWidth
            className={classes.formField}
            placeholder="Text to display"
            autoFocus
          />
          <TextField
            label="URL"
            value={linkUrl}
            onChange={(e) => setLinkUrl(e.target.value)}
            fullWidth
            className={classes.formField}
            placeholder="https://example.com"
          />
          <Box className={classes.buttonContainer}>
            <Button onClick={handleCancel} color="default">
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={!linkText || !linkUrl}
            >
              Insert
            </Button>
          </Box>
        </form>
      </Box>
    </Popover>
  );
};

export default LinkPopover;
